import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from './Menu';
import { useAuth } from '../AuthContext';
import axios from 'axios';
import CountUp from 'react-countup';
import '../CSS/Home.css'; // Le fichier CSS contient le style du spinner
import apiUrl from '../config';
import LayoutDashboard from '../layout/LayoutDashboard';

const Home = () => {
  const navigate = useNavigate();
  const { role, isAuthenticated } = useAuth();
  const today = new Date();

  // States pour les compteurs
  const [cdiCount, setCdiCount] = useState(null);
  const [declarationCount, setDeclarationCount] = useState(null);
  const [paieCount, setPaieCount] = useState(null);
  const [loading, setLoading] = useState(true); // État de chargement
  // Pour les compteurs personnels du CDI
  const [myDeclarationCount, setMyDeclarationCount] = useState(null);
  const [myDocCount, setMyDocCount] = useState(null);
  const [myPaieCount, setMyPaieCount] = useState(null);


  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  const formattedDate = today.toLocaleDateString('fr-FR', options);

  useEffect(() => {

  let isMounted = true;

  const token = localStorage.getItem('token');

  if (!token) {
    navigate('/login');
    return;
  }

  const headers = { Authorization: `Bearer ${token}` };

  const roleUpper = role?.toUpperCase();

  if (isAuthenticated && isMounted) {

    if (roleUpper === 'ADMIN') {

      axios.get(`${apiUrl}/stats-summary`, { headers })
        .then((response) => {

          setCdiCount(response.data.user_count);
          setDeclarationCount(response.data.declaration_count);
          setPaieCount(response.data.paie_count);

        })
        .catch(console.error)
        .finally(() => setLoading(false));

    }

    if (roleUpper === 'USER') {

      axios.get(`${apiUrl}/stats-user`, { headers })
        .then((response) => {

          setMyDeclarationCount(response.data.mes_declarations);
          setMyDocCount(response.data.mes_documents);
          setMyPaieCount(response.data.mes_paies);

        })
        .catch(console.error)
        .finally(() => setLoading(false));

    }

  }

  return () => {
    isMounted = false;
  };

}, [isAuthenticated, navigate, role]);



  const handleClick = () => {
  if (!isAuthenticated) {
    navigate('/login');
    return;
  }

  const roleUpper = role?.toUpperCase();

  if (roleUpper === 'ADMIN') {
    navigate('/ListeDeclarations');
  } else {
    // USER : on récupère son propre ID depuis le token
    try {
      const token = localStorage.getItem('token');
      const decoded = JSON.parse(atob(token.split('.')[1]));
      const userId = decoded.user_id;
      localStorage.setItem("selectedUserId", userId);
      navigate('/Déclarations', { state: { selectedUserId: userId } });
    } catch {
      navigate('/Déclarations');
    }
  }
};

  return (
  <LayoutDashboard>

    <div className="dashboard-page">

      <div className="date-container">
        <span className="date-prefix">Nous sommes le</span>
        {formattedDate}
      </div>

      <div className="welcome-section">
        <h2>Bienvenue dans notre portail Nova Portage </h2>
        <p>
          Ce portail est conçu pour vous offrir un accès facile à tous vos documents
          et informations essentiels, ainsi qu’à vos fiches de paie.
        </p>
      </div>

      {role?.toUpperCase() === "ADMIN" && (
        <div className="summary">
          <div className="summary-item">
            <h3>Salarié</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={cdiCount || 0} duration={2} />}
          </div>

          <div className="summary-item">
            <h3>Déclarations</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={declarationCount || 0} duration={2} />}
          </div>

          <div className="summary-item">
            <h3>Fiches de Paie</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={paieCount || 0} duration={2} />}
          </div>
        </div>
      )}

      {role?.toUpperCase() === "USER" && (
        <div className="summary">
          <div className="summary-item">
            <h3>Mes Déclarations</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={myDeclarationCount || 0} duration={2} />}
          </div>

          <div className="summary-item">
            <h3>Mes Documents</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={myDocCount || 0} duration={2} />}
          </div>

          <div className="summary-item">
            <h3>Mes Fiches de Paie</h3>
            {loading ? <div className="spinner"></div> :
              <CountUp start={0} end={myPaieCount || 0} duration={2} />}
          </div>
        </div>
      )}

      <div className="cards">
        <div className="card">
          <h2 style={{ color: "#0B349D" }}>Saisir Jours de Travail</h2>
          <button className="button" onClick={handleClick}>
            Commencer
          </button>
        </div>

        <div className="card">
          <h2 style={{ color: "#0B349D" }}>Consulter Fiches de Paie</h2>
          <button className="button" onClick={() => navigate("/Paie")}>
            Voir Mes Fiches
          </button>
        </div>

        <div className="card">
          <h2 style={{ color: "#0B349D" }}>Gestion des Documents</h2>
          <button className="button" onClick={() => navigate("/Documents")}>
            Gérer Mes Documents
          </button>
        </div>
      </div>

    </div>

  </LayoutDashboard>
  );
};

export default Home;
